import React from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { Customer } from "../../../../types/customers.types";
import EditCustomer from "../EditCustomer/EditCustomer";
import { toReais } from "../../../../utils/functions";
import DeleteCustomer from "../DeleteCustomer/DeleteCustomer";
import { ActionsCell } from "../../../../components/Table";

interface Props {
  customer: Customer;
}

/** Formata CNPJ bruto (14 dígitos) como "XX.XXX.XXX/XXXX-XX" */
function formatCNPJ(raw: string): string {
  const v = (raw ?? "").replace(/\D/g, "").substring(0, 14);
  if (v.length <= 2) return v;
  if (v.length <= 5) return `${v.substring(0, 2)}.${v.substring(2)}`;
  if (v.length <= 8) return `${v.substring(0, 2)}.${v.substring(2, 5)}.${v.substring(5)}`;
  if (v.length <= 12) return `${v.substring(0, 2)}.${v.substring(2, 5)}.${v.substring(5, 8)}/${v.substring(8)}`;
  return `${v.substring(0, 2)}.${v.substring(2, 5)}.${v.substring(5, 8)}/${v.substring(8, 12)}-${v.substring(12)}`;
}

const CustomerRow: React.FC<Props> = ({ customer }: Props) => {
  return (
    <TableRow
      key={customer.document}
      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      hover
    >
      <TableCell component="th" scope="row" sx={{ whiteSpace: "nowrap" }}>
        {customer.name}
      </TableCell>
      <TableCell sx={{ whiteSpace: "nowrap" }}>
        <span style={{ border: "none", backgroundColor: "transparent" }}>
          {formatCNPJ(customer.document)}
        </span>
      </TableCell>
      <TableCell sx={{ whiteSpace: "nowrap" }}>{toReais(customer.balance ?? 0)}</TableCell>
      <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
        <ActionsCell style={{ justifyContent: "flex-end" }}>
          <DeleteCustomer customer={customer} />
          <EditCustomer customer={customer} />
        </ActionsCell>
      </TableCell>
    </TableRow>
  );
};

export default CustomerRow;
